import PropTypes from 'prop-types'
import { forwardRef } from 'react'

import { Box, Icon } from '@redriverpress/system'

const types = {
  error: {
    background: 'red50',
  },
  warning: {
    background: 'yellow200',
  },
  message: {
    background: 'blue50',
  },
  success: {
    background: 'green50',
  },
}

const boldTypes = {
  error: {
    background: 'red100',
  },
  warning: {
    background: 'yellow400',
  },
  message: {
    background: 'blue100',
  },
  success: {
    background: 'green100',
  },
}

const Alert = forwardRef(
  ({ icon, children, type, iconColor, bold, ...props }, ref) => {
    const bg = bold ? boldTypes[type].background : types[type].background
    return (
      <Box
        ref={ref}
        p={3}
        bg={bg}
        fontSize={0}
        borderRadius='rounded'
        display='flex'
        alignItems='center'
        {...props}
      >
        {icon && (
          <Box>
            <Icon icon={icon} color={iconColor} mr={3} />
          </Box>
        )}
        <Box>{children}</Box>
      </Box>
    )
  }
)

Alert.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  iconColor: PropTypes.string,
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(Object.keys(types)),
  bold: PropTypes.bool,
}

Alert.defaultProps = {
  icon: 'exclamation-triangle',
  iconColor: 'black',
  type: 'error',
}

export default Alert
